import { Button, Grid, Typography, useTheme } from '@mui/material';
import AcceptInvitationForm from './components/AcceptInvitationForm';
import UserService from '../../services/user.service';
import useAlert from '../../hooks/useAlert';
import React, { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { USER_INVITATION_STATUS, UserInvitation } from 'vendor-marketplace-shared-library';
import { useNavigate } from 'react-router-dom';
import { ACCEPT_USER_INVITATIONS, DECLINE_USER_INVITATIONS } from '../../error-messages';

export default function AcceptInvitationPage() {
  const alert = useAlert();
  const { userQuery, logout } = useAuth();
  const navigation = useNavigate();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const invitation = (userQuery.data?.me?.phoneContactMethod?.userInvitations ?? [])
    .filter((invitation: UserInvitation) =>
      [USER_INVITATION_STATUS.CREATED, USER_INVITATION_STATUS.SENT].includes(
        invitation.inviteStatus!,
      ),
    )
    .sort(
      (a: UserInvitation, b: UserInvitation) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    )[0];

  const onAccept = async () => {
    try {
      setLoading(true);
      await UserService.acceptUserInvitation(invitation.id);
      await userQuery.refetch();
      navigation('/');
    } catch (error: any) {
      alert.setAlert({
        message: error.response?.data?.error || ACCEPT_USER_INVITATIONS,
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const onDecline = async () => {
    try {
      setLoading(true);
      await UserService.declineUserInvitation(invitation.id);
      await userQuery.refetch();
      navigation('/onboarding');
    } catch (error: any) {
      alert.setAlert({
        message: error.response?.data?.error || DECLINE_USER_INVITATIONS,
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item>
        <Grid
          container
          sx={[{ border: `1px ${theme.palette.secondary.light} solid` }, styles.card]}
        >
          <Grid item>
            <img height={75} width={200} src={'procure-logo-black.png'} alt={'logo'} />
          </Grid>
          <Grid item>
            <AcceptInvitationForm
              onAccept={onAccept}
              onDecline={onDecline}
              invitation={invitation}
              loading={loading}
            />
          </Grid>

          <Grid item>
            <Grid container sx={styles.subContainer}>
              <Grid item>
                <Typography variant={'caption'}>Already have an account?</Typography>
              </Grid>
              <Grid item>
                <Button
                  size='small'
                  onClick={() => {
                    logout();
                    navigation('/login');
                  }}
                >
                  Sign in
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    height: '100vh',
  },
  card: {
    maxWidth: '650px',
    minWidth: '320px',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: 2,
    paddingTop: 6,
    paddingBottom: 6,
    rowGap: 4,
    flex: 1,
  },
  subContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: 1,
  },
};
